/**
 * ThemePreview — Iter 99 (placeholder)
 *
 * El selector de paletas de modo claro se retiró en Iter 99 porque nunca
 * llegó a integrarse limpiamente con todos los componentes de la app.
 * La app ahora va siempre en modo oscuro.
 *
 * Esta página existe sólo para que enlaces antiguos a `/preview/themes`
 * no rompan; redirige al Dashboard tras 1.5s.
 */
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Palette, ArrowRight } from "lucide-react";

export default function ThemePreviewPlaceholder() {
  const navigate = useNavigate();
  useEffect(() => {
    const t = setTimeout(() => navigate("/", { replace: true }), 2500);
    return () => clearTimeout(t);
  }, [navigate]);
  return (
    <div className="min-h-screen flex items-center justify-center p-6" data-testid="theme-removed">
      <div className="max-w-md text-center space-y-4">
        <Palette className="w-12 h-12 text-amber-400 mx-auto opacity-80" />
        <h1 className="text-xl font-bold text-zinc-100">El selector de paletas se retiró</h1>
        <p className="text-sm text-zinc-400">
          RotulaciónDNF va ahora siempre en modo oscuro con la paleta amber/zinc oficial.
          Redirigiendo al Dashboard…
        </p>
        <button
          onClick={() => navigate("/", { replace: true })}
          className="inline-flex items-center gap-2 px-4 py-2 bg-amber-500 hover:bg-amber-400 text-zinc-900 rounded font-semibold text-sm"
          data-testid="btn-volver-dashboard">
          Ir al Dashboard <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
